import type { NodeViewConstructor } from '@atlaskit/editor-common/lazy-node-view/types';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import type { Node as PMNode, Schema } from '@atlaskit/editor-prosemirror/model';
import { DOMSerializer } from '@atlaskit/editor-prosemirror/model';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';

const injectNodeViewNodeTypeList: readonly string[] = [
	'paragraph',
	'heading',
	'bulletList',
	'orderedList',
	'blockquote',
	'rule',
	'decisionList',
	'taskList',
	'layoutColumn',
	'hardBreak',
	'layoutSection',
] as const;

const key = new PluginKey('editorNativeAnchorSupportPlugin');

// Internal plugin to enable native anchor support in the editor.
// This plugin injects node views for specific node types (e.g., 'paragraph', 'heading')
// that do not already have a nodeView, allowing them to be rendered with native anchors when needed.
export const createEditorNativeAnchorSupportPlugin = (schema: Schema): SafePlugin => {
	const nodeViewEntries: [string, NodeViewConstructor][] = [];

	schema.spec.nodes.forEach((nodeName, nodeSpec) => {
		if (injectNodeViewNodeTypeList.includes(nodeName)) {
			if (nodeSpec.toDOM && typeof nodeSpec.toDOM === 'function') {
				const toDOM = nodeSpec.toDOM.bind(nodeSpec);
				nodeViewEntries.push([
					nodeName,
					(node: PMNode) => DOMSerializer.renderSpec(document, toDOM(node)),
				]);
			}
		}
	});

	return new SafePlugin({
		key,
		props: {
			nodeViews: Object.fromEntries(nodeViewEntries),
		},
	});
};
